<template>
  <detail-template
    :classCustom="['detail-docs', tabHistory ? 'detailShowHistory' : '']"
  >
    <template #content>
      <transition name="el-fade-in-linear">
        <el-tooltip content="Lịch sử tác động" placement="left">
          <div
            v-show="!tabHistory"
            @click="tabHistory = true"
            class="btn-show-history clickable flex-row flex__center border-radius__50"
          >
            <el-badge is-dot class="inline-flex">
              <i class="fas fa-history"></i>
            </el-badge>
          </div>
        </el-tooltip>
      </transition>

      <!-- <el-page-header
        :title="''"
        class="has-border__bottom"
        @back="$emit('back')"
      > -->
      <div class="back-icon border-radius__50 clickable flex-row flex__center">
        <i @click="$emit('back')" class="el-icon-back font-size__large"></i>
      </div>
      <!-- <template #content> -->
      <div class="header">
        <slot name="header" />
      </div>
      <!-- </template> -->
      <!-- </el-page-header> -->
      <!--      -->
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <slot name="main" />
        </div>
      </VuePerfectScrollbar>
      <!--      -->
      <div class="footer">
        <div class="flex-row flex__left form-button__action">
          <slot name="footer" />
        </div>
      </div>
      <!--      -->
      <transition name="slide">
        <div v-show="tabHistory">
          <slot name="side" :hideSide="hideSide" :="tabHistory" />
        </div>
      </transition>
    </template>
  </detail-template>
</template>

<script>
import DetailTemplate from "../detail";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "detail-template-v2",
  components: { DetailTemplate, VuePerfectScrollbar },
  data() {
    return {
      tabHistory: true,
    };
  },
  methods: {
    hideSide() {
      this.tabHistory = false;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/layout/detail-template-v2.vue